// Toggle.jsx
import React, { useCallback } from "react";

export default function Toggle({
  checked = false,
  onChange,
  disabled = false,
  ariaLabel = "Toggle",
}) {
  const toggle = useCallback(() => {
    if (disabled) return;
    onChange?.(!checked);
  }, [checked, disabled, onChange]);

  const onKeyDown = (e) => {
    if (disabled) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggle();
    }
  };

  return (
    <div
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      tabIndex={disabled ? -1 : 0}
      onClick={toggle}
      onKeyDown={onKeyDown}
      style={{
        width: 36,
        height: 20,
        borderRadius: 100,
        background: checked
          ? "var(--color-surface-surface-accent, #359FBB)"
          : "var(--color-surface-surface-primary, rgba(238, 237, 233, 0.85))",
        position: "relative",
        cursor: disabled ? "not-allowed" : "pointer",
        boxShadow: checked ? "0px 0px 15px rgba(0,0,0,0.15)" : "none",
        opacity: disabled ? 0.6 : 1,
        outline: "none",
      }}
    >
      <div
        style={{
          width: 16,
          height: 16,
          borderRadius: 9999,
          background: checked
            ? "var(--color-surface-surface-primary, rgba(238, 237, 233, 0.85))"
            : "var(--color-surface-surface-white, #fff)",
          position: "absolute",
          top: 2,
          left: checked ? 18 : 2,
          boxShadow: "0px 2px 4px rgba(39,39,39,0.10)",
          transition: "left 0.2s",
        }}
      />
    </div>
  );
}
